<div
  class="overflow-hidden rounded-lg bg-white dark:bg-gray-900/20 shadow-sm text-primary-500 dark:text-gray-100"
>
  <img
    [src]="rep().images.jpg"
    [alt]="rep().firstName + ' ' + rep().lastName"
    class="px-4 pt-3 w-full"
  />

  <div
    class="-mt-4 -ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap px-4 pt-5 sm:px-6"
  >
    <div class="mt-4 ml-4 cursor-default">
      <h2 class="text-base font-header font-semibold">
        {{ rep().firstName }} {{ rep().lastName }}
      </h2>
    </div>
  </div>

  <div class="px-6 pb-2 sm:pb-2">Properties of The Villages</div>

  <div class="px-4 pb-5 sm:px-6 sm:pb-6 grid grid-cols-2 gap-2">
    <button
      type="button"
      class="rounded-md px-2.5 py-1.5 text-sm font-semibold border border-primary-500 hover:bg-primary-500 hover:text-white w-full mt-6 cursor-pointer"
      (click)="setRepFilter.emit(rep().id!.toString())"
    >
      My Listings
    </button>

    <button
      type="button"
      class="rounded-md px-2.5 py-1.5 text-sm font-semibold border border-primary-500 hover:bg-primary-500 hover:text-white w-full mt-6 cursor-pointer"
      (click)="bioPostMessage()"
    >
      Bio
    </button>
  </div>
</div>
